import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAyatById, updateAyat } from './_request';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const EditAyat = () => {
    const location = useLocation();  
    const { id } = location.state; 
  const { authToken } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    title: '',
    ayat: '',
    hawala: '',
    tarjuma: '',
    status: 'Active',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  useEffect(() => {
  const fetchAyat = async () => {
    try {
      const response = await getAyatById(authToken, id);
      if (response?.Result && response?.Data) {
        setForm(response.Data);
      }
    } catch (error) {
      console.error("Error fetching Ayat:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchAyat();
}, [id, authToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await updateAyat(authToken, id, form);
      if (response?.Result) {
        navigate('/home');
      } else {
        alert('Failed to update Ayat');
      }
    } catch (error) {
      console.error('Update error:', error);
    }
  };



  if (loading) return <div style={{ textAlign: 'center', padding: '16px' }}><CircularProgress /></div>;

  return (
    <div className="max-w-full mx-auto p-6 bg-white shadow-md rounded-lg mt-8">
      <h2 className="text-2xl font-semibold mb-4">Edit Ayat / Rewayat</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-medium">Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Ayat / Rewayat</label>
          <textarea
            name="ayat"
            value={form.ayat}
            onChange={handleChange}
            rows={4}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Hawala</label>
          <input
            type="text"
            name="hawala"
            value={form.hawala}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Tarjuma</label>
          <textarea
            name="tarjuma"
            value={form.tarjuma}
            onChange={handleChange}
            rows={4}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Status</label>
          <Select
            value={form.status}
            onChange={handleChange}
            fullWidth
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Not Active">Not Active</MenuItem>
          </Select>
        </div>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Update'}
        </Button>
      </form>
    </div>
  );
};

export default EditAyat;
